module.exports = __webpack_public_path__ + "img/unsucessfull.c0715038.png";